import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type AlertBundle = {
  agencyId: number
  calls: number
  emails: number
  todos: number
  chat: number
}

export type TopBarAlertsState = {
  bundles: AlertBundle[]
  lastFetchAt: number | null
}

const initialState: TopBarAlertsState = {
  bundles: [],
  lastFetchAt: null,
}

const topBarAlertsSlice = createSlice({
  name: "topBarAlerts",
  initialState,
  reducers: {
    setBundles: (state, action: PayloadAction<AlertBundle[]>) => {
      state.bundles = action.payload
      state.lastFetchAt = Date.now()
    },
  },
})

export const { setBundles } = topBarAlertsSlice.actions
export default topBarAlertsSlice.reducer
